const ja = {
  // Navbar
  "nav.home": "ホーム",
  "nav.creators": "クリエイター",
  "nav.campaigns": "キャンペーン",
  "nav.rewards": "報酬",
  "nav.community": "コミュニティ",
  "nav.pricing": "料金",
  "nav.registerCreator": "クリエイター登録",
  "nav.login": "ログイン",
  "nav.start": "始める",
  "nav.mypage": "マイページ",
  "nav.settings": "設定",
  "nav.logout": "ログアウト",
  "nav.tokens": "トークン",
  "nav.brands": "ブランド",

  // Hero Section
  "hero.joinCampaign": "キャンペーンに参加",
  "hero.exploreCreators": "クリエイターを探す",

  // Service Intro
  "service.howItWorks": "使い方",
  "service.title": "K-POPからドラマ、映画、ウェブトゥーンまで",
  "service.titleHighlight": "あらゆるエンタメIPの創作プラットフォーム",
  "service.desc": "CreatorVerseはK-POPアイドル、ドラマ制作会社、映画会社、ウェブトゥーンスタジオの公式IPとAI技術を繋ぎ、すべてのファンが創作物を制作できるプラットフォームです。",
  "service.step.selectIP": "IPを選ぶ",
  "service.step.selectIP.desc": "K-POP、ドラマ、映画、ウェブトゥーンから選択",
  "service.step.joinCampaign": "キャンペーン参加",
  "service.step.joinCampaign.desc": "MV・ドラマシーン・ポスターなど好きなキャンペーンを選ぼう",
  "service.step.aiCreate": "AIで制作",
  "service.step.aiCreate.desc": "AIツールでオリジナル作品を制作しよう",
  "service.step.shareReward": "シェア＆報酬",
  "service.step.shareReward.desc": "コミュニティでシェアしてXPを獲得しよう",
  "service.cta.title": "今すぐファンクリエイターになろう",
  "service.cta.desc": "K-POP、ドラマ、映画、ウェブトゥーン — 好きなIPでAIを使ってオリジナル作品を作ろう",
  "service.cta.startCampaign": "キャンペーン開始",
  "service.cta.exploreIP": "IPを探す",

  // Latest Campaigns
  "latest.title": "今すぐ参加できる",
  "latest.titleHighlight": "最新エンタメキャンペーン",
  "latest.viewAll": "全キャンペーン",
  "latest.viewAllCampaigns": "すべてのキャンペーンを見る",
  "latest.filter.all": "すべて",
  "latest.filter.kpop": "K-POP",
  "latest.filter.drama": "ドラマ",
  "latest.filter.film": "映画",
  "latest.filter.webtoon": "ウェブトゥーン",
  "latest.participation": "参加率",
  "latest.participants": "名",

  // Footer
  "footer.platform": "プラットフォーム",
  "footer.exploreIdols": "アイドルを探す",
  "footer.campaigns": "キャンペーン",
  "footer.community": "コミュニティ",
  "footer.pricing": "料金",
  "footer.createCampaign": "キャンペーン作成",
  "footer.artist": "アーティスト",
  "footer.artistRegister": "アーティスト登録",
  "footer.ipManagement": "IP管理",
  "footer.campaignCreate": "キャンペーン出題",
  "footer.fanStats": "ファン統計",
  "footer.support": "サポート",
  "footer.newsletter": "最新情報を受け取る",
  "footer.newsletterDesc": "新しいキャンペーンやアイドルニュースをお届け",
  "footer.emailPlaceholder": "メールアドレス",
  "footer.subscribed": "登録完了！",
  "footer.startFree": "無料で始める",
  "footer.terms": "利用規約",
  "footer.privacy": "プライバシーポリシー",
  "footer.copyright": "© 2026 CreatorVerse. All rights reserved.",

  // Campaigns page
  "campaigns.breadcrumb.home": "ホーム",
  "campaigns.breadcrumb.campaigns": "キャンペーン",
  "campaigns.hero.title": "すべてのアーティストの",
  "campaigns.hero.titleHighlight": "キャンペーンを探索",
  "campaigns.hero.desc": "アーティストが提供するキャンペーンに挑戦してAI動画を制作しよう。",
  "campaigns.hero.createVideo": "動画を制作",
  "campaigns.filterByArtist": "アーティスト別キャンペーン",
  "campaigns.all": "すべて",
  "campaigns.noResults": "検索結果がありません",
  "campaigns.resetFilters": "フィルターをリセット",
  "campaigns.total": "計",
  "campaigns.totalSuffix": "件のキャンペーン",
  "campaigns.searchPlaceholder": "キャンペーン名で検索...",
  "campaigns.allArtists": "全アーティスト",
  "campaigns.allDifficulty": "全難易度",
  "campaigns.difficulty.easy": "初級",
  "campaigns.difficulty.medium": "中級",
  "campaigns.difficulty.hard": "上級",
  "campaigns.sort.latest": "最新順",
  "campaigns.sort.popular": "人気順",
  "campaigns.sort.reward": "報酬高い順",
  "campaigns.sort.deadline": "締切間近",
  "campaigns.progress": "進捗",
  "campaigns.participate": "名参加",
  "campaigns.startCampaign": "キャンペーン開始",

  // Login
  "login.title": "ログイン",
  "login.welcome": "CreatorVerseへようこそ！",
  "login.google": "Googleで続ける",
  "login.kakao": "Kakaoで続ける",
  "login.orEmail": "またはメールでログイン",
  "login.email": "メールアドレス",
  "login.password": "パスワード",
  "login.forgotPassword": "パスワードを忘れた方",
  "login.submit": "ログイン",
  "login.loading": "ログイン中...",
  "login.noAccount": "アカウントをお持ちでない方は",
  "login.signup": "新規登録",
  "login.testHint": "テスト: メール(@含む) + 8文字以上のパスワード",
  "login.error.default": "ログインに失敗しました",

  // Signup
  "signup.step.account": "アカウント情報",
  "signup.step.profile": "プロフィール設定",
  "signup.accountInfo": "アカウント情報を入力",
  "signup.email": "メールアドレス *",
  "signup.password": "パスワード *",
  "signup.passwordConfirm": "パスワード確認 *",
  "signup.next": "次へ",
  "signup.complete": "登録完了",
  "signup.hasAccount": "すでにアカウントをお持ちですか？",
  "signup.login": "ログイン",
  "signup.profileSetup": "ファンプロフィール設定",
  "signup.nickname": "ニックネーム *",
  "signup.nicknamePlaceholder": "コミュニティで使うニックネーム",
  "signup.favoriteGroup": "推しグループ（任意）",
  "signup.agreeTerms": "に同意します *",
  "signup.agreeMarketing": "マーケティング情報受信に同意します（任意）",
  "signup.terms": "利用規約",
  "signup.privacy": "プライバシーポリシー",
  "signup.and": "・",
  "signup.done.title": "登録完了！",
  "signup.done.plan": "プランで開始します",
  "signup.done.tokenGranted": "トークンが付与されました！",
  "signup.done.joinCampaign": "キャンペーンに参加",
  "signup.done.goHome": "ホームへ",
  "signup.changePlan": "プランを変更",
  "signup.selectedPlan": "選択中のプラン",
  "signup.tokensPerMonth": "トークン/月",
  "signup.aiUsage": "AI動画生成に使用",

  // Common
  "common.language": "言語",
};

export default ja;
